import React from "react";
import OccurrenceItem from "./OccurrenceItem";
import Pill from "../ui/Pill";

// A auditoria limpa é o caso mais importante desta tela: a lista antiga
// sumia inteira e quem rodava não sabia se tinha checado ou falhado.
function CleanAudit({ scope }) {
  return (
    <div className="card-state">
      <Pill variant="success">Tudo consistente</Pill>
      <p className="empty-title">Nenhuma inconsistência encontrada</p>
      {scope && <p className="empty-help">{scope}</p>}
    </div>
  );
}

function OccurrenceList({ items, cleanScope }) {
  if (items.length === 0) return <CleanAudit scope={cleanScope} />;

  return items.map((item, index) => (
    <OccurrenceItem key={`${item.description}-${index}`} item={item} />
  ));
}

export default OccurrenceList;
